<template>
  <div>
    <div>
      <v-data-table
        :headers="headers"
        :items="dataTable"
        hide-default-footer
        :no-data-text="$t('common.nodata')"
        item-key="id"
        fixed-header
        class="custom-price-data-table gray10"
        :header-props="{ 'sort-icon': '$sortIcon' }"
      >
        <template v-slot:item.createdDate="{ item }">
          {{ item.createdDate | dateFormat }}
        </template>

        <template v-slot:item.source="{ item }">
          {{
            item.source === "STOP_LIMIT_CONDITION"
              ? $t("stopLimitOrders.stopLimit")
              : item.source === "OCO_CONDITION"
              ? $t("stopLimitOrders.ocoStopLimit")
              : "--"
          }}
        </template>

        <template v-slot:item.direction="{ item }">
          {{
            item.direction == "BUY"
              ? $t("stopLimitOrders.buy")
              : $t("stopLimitOrders.sell")
          }}
        </template>

        <template v-slot:item.activationPrice="{ item }">
          <div class="font-Regular-12">
            {{
              $thousandMask(
                item.activationPrice,
                pairCoinScales[item.symbol].frontBaseCoinScale
              )
            }}
            <span class="font-Regular-16">
              <template v-if="item.momentMarketPrice >= item.activationPrice">
                =>
              </template>
              <template v-else>
                &#61;&lt;
              </template>
            </span>
          </div>
        </template>

        <template v-slot:item.operation="{ item }">
          <v-btn
            color="error"
            text
            class="ms-2"
            @click="() => openCancelModal(item.id)"
            >{{ $t("stopLimitOrders.cancel") }}
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <!--    cancel modal-->
    <v-dialog v-model="cancelOrder" width="500">
      <v-card>
        <v-card-title>
          {{ $t("stopLimitOrders.cancelOrder") }}
        </v-card-title>
        <v-card-text>
          {{ $t("stopLimitOrders.cancelOrderDescription") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="cancel(cancelOrderId)">
            {{ $t("stopLimitOrders.confirm") }}
          </v-btn>
          <v-btn color="primary" text @click="cancelOrder = false">
            {{ $t("stopLimitOrders.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ExchangeService } from "@/services";
import dayjs from "@/utiles/dayjs";
import $thousandMask from "@/mixins/thousandMask";
import thousandMask from "@/mixins/thousandMask";

export default {
  computed: {
    thousandMask() {
      return thousandMask;
    }
  },
  mixins: [$thousandMask],
  props: {
    dataTable: {
      type: Array
    },
    pairCoinScales: {
      type: Array
    }
  },
  data() {
    return {
      headers: [
        { text: "#", value: "index", width: "50px", align: "right" },
        {
          text: this.$t("stopLimitOrders.time"),
          value: "createdDate",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.pairCoin"),
          value: "symbol",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.orderType"),
          value: "source",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.tradeDirection"),
          value: "direction",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.activationPrice"),
          value: "activationPrice",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.price"),
          value: "orderPrice",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.amount"),
          value: "amount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.refCode"),
          value: "trackingCode",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("stopLimitOrders.operation"),
          value: "operation",
          sortable: false,
          align: "center"
        }
      ],
      isOrderDetailModalOpen: false,
      cancelOrder: false,
      cancelOrderId: "",
      PairCoinScales: []
    };
  },
  filters: {
    dateFormat(date) {
      return dayjs(date).format("YYYY/MM/DD-HH:mm");
    }
  },
  methods: {
    openCancelModal(id) {
      this.cancelOrder = true;
      this.cancelOrderId = id;
    },
    getOrderDetails(orderId) {
      ExchangeService.getOrderDetails(orderId).then(response => {
        this.orderDetailsData = response.data;
        this.isOrderDetailModalOpen = true;
      });
    },
    cancel(orderId) {
      this.$emit("cancelCreatedOrder", orderId);
      this.cancelOrderId = "";
      this.cancelOrder = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
